import React, { useContext } from "react"
import ContentCard from "../../../components/ContentCard"
import { Link } from "react-router-dom"
import AppContext from "../../../shared/AppContext"
import moment from "moment-timezone"
import { MdOutlineLockClock, MdLock } from "react-icons/md"

const ListCard = ({ thumbnail, keywordSearch, isAdmin, model }) => {
  const imageURL =
    thumbnail ||
    "https://s3.amazonaws.com/dev-etr/images/fallback/Drilldown.png"

  const { trackEvent } = useContext(AppContext)
  const isExclusive = !model.roles.includes("DrillDowns")
  const isEmbargoed =
    !!model.embargoEndDate && moment().isBefore(model.embargoEndDate)
  const renderIndicator = () => {
    if (isExclusive) {
      return (
        <>
          <MdLock className="icon" />
          Exclusive
        </>
      )
    }
    if (isEmbargoed) {
      return (
        <>
          <MdOutlineLockClock className="icon" />
          Embargoed until{" "}
          {moment
            .tz(model.embargoEndDate, moment.tz.guess())
            .format("MMMM Do YYYY, h:mm A z")}
        </>
      )
    }
    return null
  }

  return (
    <Link
      data-cy={model.slug}
      to={`/research/drill-downs/${model.slug}`}
      onClick={() => {
        trackEvent("DrillDowns Search List Click", {
          name: model.title,
          url: "/research/drill-downs/" + model.slug,
          fromKeywordSearch: keywordSearch,
        })
      }}
    >
      <ContentCard className="card">
        <div className="card-info">
          {isAdmin && (isEmbargoed || isExclusive) ? (
            <div className="embargo-date" data-cy={"embargo-indicator"}>
              {renderIndicator()}
            </div>
          ) : null}

          <div className="drilldown">
            <div className="card-thumbnail">
              <img src={imageURL} />
            </div>

            <div className="card-text">
              <div className="card-title">
                <h3 data-cy="list-card-title">{model.displayName}</h3>
              </div>

              <div className="card-description">
                {model.description}
                {!!model.vendors.length && (
                  <>
                    &nbsp;
                    <span className="companies-title">Related Companies:</span>
                    &nbsp;
                    <span className="companies">
                      {model.vendors.join(", ")}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="card-data">
          <div className="card-background-icon">
            <span className="glyphicon glyphicon-sort-by-attributes-alt" />
          </div>

          <div className="icon-group date">
            <i className="far fa-calendar-check"></i>

            <div className="text">
              {moment
                .tz(model.launchDate, moment.tz.guess())
                .format("MMMM Do YYYY, h:mm A z")}
              <p className="icon-label">Launch Date</p>
            </div>
          </div>

          <div className="icon-group participants">
            <i className="fas fa-user-friends"></i>
            <div className="text">
              {model.participantCount}
              <p className="icon-label">Participants</p>
            </div>
          </div>
          <i className="fas fa-2x fa-chevron-right"></i>
        </div>
      </ContentCard>
    </Link>
  )
}

export default ListCard
